import React, { useEffect } from "react";

import {
  CompassColor,
  CompassLoader,
  Stack,
} from "@noom/wax-component-library";

import {
  QuestionComponentProps,
  QuestionDefinition,
} from "@/components/survey/Question";
import { ErrorState } from "@/constants";
import { useGoto, useScaleOptInEligibility } from "@/hooks";
import { MissingAutologinError } from "@/hooks/useScaleOptInEligibility";

import { BaseInterstitial } from "../core";

const QUESTION_ID = "scaleOptInEligibilityCheck";

const ScaleOptInEligibilityCheckQuestion: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
}) => {
  const { canShowOptIn, isLoading, error } = useScaleOptInEligibility();
  const goto = useGoto();

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (error instanceof MissingAutologinError) {
      goto.error(ErrorState.MISSING_AUTOLOGIN);
      return;
    }
    if (error || !canShowOptIn) {
      goto.error();
      return;
    }
    onClickNext(true);
  }, [isLoading, canShowOptIn, error, goto, onClickNext]);

  return (
    <BaseInterstitial
      centerChildren
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      questionId={QUESTION_ID}
    >
      <Stack alignItems="center">
        <CompassLoader color={CompassColor.black} size="lg" />
      </Stack>
    </BaseInterstitial>
  );
};

export const Q_SCALE_OPT_IN_ELIGIBILITY_CHECK: QuestionDefinition = {
  id: QUESTION_ID,
  shouldShowQuestion: () => true,
  component: ScaleOptInEligibilityCheckQuestion,
};
